import {
  SelectedLinesInfo,
  buildMultilineAction,
  addLineIndent,
  getPrecedingLine,
} from '../utils'
import { matchList } from '../listUtils'
import { markdownConfig } from '../../config'

const computeIndentStep = (info: SelectedLinesInfo): number | null => {
  const defaultStep = Math.max(0, markdownConfig.defaultIndent)
  const firstLine = info.lines[0] ?? ''
  const firstMatch = matchList(firstLine)

  if (!firstMatch) return null

  const curIndentLen = (firstMatch[1] || '').length

  let parentOrSiblingIndentLen: number = 0
  let parentOrSiblingMarkerLen: number = defaultStep
  let deeperIndentLen: number | null = null

  // Walk upwards to find the closest list line that is not deeper than the current.
  // Also, find the nearest deeper level if it exists.
  const beforeText = info.before
  let pos = beforeText.length - 2 // -2 to skip the last newline
  while (pos >= 0) {
    const { line, lineStart: prevNl } = getPrecedingLine(beforeText, pos)

    const m = matchList(line)
    if (!m) break

    const indLen = (m[1] || '').length
    if (indLen <= curIndentLen) {
      parentOrSiblingIndentLen = indLen
      parentOrSiblingMarkerLen = (m[2] || '').length
      break
    }

    if (deeperIndentLen == null || indLen < deeperIndentLen) {
      deeperIndentLen = indLen
    }
    // Move to the previous line (character before the newline)
    pos = prevNl - 1
  }

  const parentOrSiblingWithMarkerIndentLen =
    parentOrSiblingIndentLen + parentOrSiblingMarkerLen

  if (deeperIndentLen) {
    if (
      parentOrSiblingWithMarkerIndentLen < deeperIndentLen &&
      curIndentLen < parentOrSiblingWithMarkerIndentLen
    ) {
      return parentOrSiblingWithMarkerIndentLen - curIndentLen
    }

    return deeperIndentLen - curIndentLen
  }

  if (curIndentLen < parentOrSiblingWithMarkerIndentLen) {
    return parentOrSiblingWithMarkerIndentLen - curIndentLen
  }

  return null
}

export const indentListAction = buildMultilineAction(
  computeIndentStep,
  addLineIndent,
)
